import { render, staticRenderFns } from "./data-setting.vue?vue&type=template&id=2164228c&scoped=true&"
import script from "./data-setting.vue?vue&type=script&lang=js&"
export * from "./data-setting.vue?vue&type=script&lang=js&"
import style0 from "./data-setting.vue?vue&type=style&index=0&id=2164228c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164228c",
  null
  
)

export default component.exports